import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface ConfettiEffectProps {
  trigger: boolean;
  onComplete?: () => void;
}

const ConfettiEffect: React.FC<ConfettiEffectProps> = ({ trigger, onComplete }) => {
  const [pieces, setPieces] = useState<Array<{ id: number; x: number; color: string; delay: number }>>([]);

  useEffect(() => {
    if (trigger) {
      const newPieces = Array.from({ length: 30 }, (_, i) => ({
        id: i,
        x: Math.random() * 100,
        color: ['#00C3FF', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899'][
          Math.floor(Math.random() * 6)
        ],
        delay: Math.random() * 0.3
      }));
      setPieces(newPieces);

      const timer = setTimeout(() => {
        setPieces([]);
        if (onComplete) onComplete();
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [trigger, onComplete]);

  return (
    <div className="fixed inset-0 pointer-events-none z-50">
      <AnimatePresence>
        {pieces.map((piece) => (
          <motion.div
            key={piece.id}
            initial={{
              top: '50%',
              left: `${piece.x}%`,
              opacity: 1,
              scale: 1,
              rotate: 0
            }}
            animate={{
              top: ['50%', '100%'],
              opacity: [1, 0],
              scale: [1, 0.5],
              rotate: [0, 360]
            }}
            exit={{ opacity: 0 }}
            transition={{
              duration: 1.5,
              delay: piece.delay,
              ease: 'easeOut'
            }}
            className="absolute"
          >
            <div
              style={{ backgroundColor: piece.color }}
              className="w-3 h-3 rounded-full"
            />
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default ConfettiEffect;
